module.exports = __webpack_public_path__ + "static/media/oficinas_mobile.ba86fe29.webp";